//
// AbstractSlider.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../PromptSpecialization";
import "../PromptOrientation";
import "../../../dataDefinition/DataItem";
import "../../../common/constraints/AbstractConstraintType";

var AbstractSlider = createModule("BIRD::AbstractSlider", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PromptSpecialization"], EventDispatcher, [
    ,
    {
        orientation: 4,
        maxVariable: 1,
        minVariable: 1,
        constraint: 1,
        defaultFormat: 7,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractSlider;
